import React from "react";
// import { Link } from "gatsby";
// import Img from "gatsby-image";

const LianXi = () => {
  return (
    <table width="100%" border="0" cellSpacing="0" cellPadding="0">
    <tbody><tr>
      <td height="26">电话:021-62682618</td>
    </tr>
    <tr>
      <td height="26">&nbsp;&nbsp;&nbsp;&nbsp; 021-51151242 </td>
    </tr>
    <tr>
      <td height="26">传真:021-54491700<br /></td>
    </tr>
<tr>
      <td height="26">Email:<a href="mailto:market@dongdahuoyun.com">market@dongdahuoyun.com</a></td>
  </tr>
<tr>
      <td height="26">地址:沪青平公路248弄15号106室</td>
  </tr>
  </tbody>
  </table>
  );
};

export default LianXi;
